<template lang="pug">
  server-data(
    :method="$api.system.getTeacherLevels"
    v-slot="{ loading, serverData }"
  )
    v-select(
      v-bind="$attrs"
      :value="value"
      :items="serverData || []"
      :loading="loading"
      item-text="level_name"
      item-value="id"
      name="education_level"
      label="Уровень образования"
      filled
      rounded
      @input="$emit('input', $event)"
    )
</template>

<script>
export default {
  props: {
    value: { type: Number, default: null },
  },
};
</script>
